import React, { useEffect, useState } from 'react';
import MenuItemReadView from './MenuItemReadView';

import { Typography, Box, Paper, List, ListItem, ListItemText } from '@mui/material';
import Alert from '@mui/material/Alert';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import MenuEditIconButton from './MenuEditIconButton';
import MenuRemoveIconButton from './MenuRemoveIconButton';
import MenuItemCreatorEditorButton from './MenuItemCreatorEditorButton';
import { useLocale } from '../../../i18n/LanguageContext';

export default function MenuReadView(props) {

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const hasMenuItems = Array.isArray(props.menu?.items) && props.menu.items.length > 0;
  const { t } = useLocale();

  const menuNumber = props.menuNumber || 1;

  function handleEditMenu(menu) {
    props.onMenuChange(menu);
  }

  function handleRemoveMenu() {
    props.onRemoveMenu(props.menu.id)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 16 }}>
        { props.errorOnRemove ? (<Alert severity="error" ><b>{t('kitchenMenus.removeError')}</b></Alert>) : ''}
        <div style={{ display: 'flex', flexDirection: isSmallScreen ? 'column' : 'row', justifyContent: 'space-between', alignItems: isSmallScreen ? 'stretch' : 'baseline', gap: isSmallScreen ? 6 : 0 }}>
          <Typography variant="h5" gutterBottom mb={isSmallScreen ? 1 : 3} mt={2} style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <span style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 42,
              height: 26,
              borderRadius: 12,
              backgroundColor: '#2693ca',
              color: '#ffffff',
              fontSize: 18,
              fontWeight: 300,
              lineHeight: 1
            }}>
              {menuNumber}
            </span>
            <span>{props.menu.name}</span>
            <span style={{
              fontSize: 12,
              marginLeft: 2,
              padding: '2px 8px',
              borderRadius: 10,
              backgroundColor: props.menu.isActive ? '#e8f5e9' : '#f5f5f5',
              color: props.menu.isActive ? '#2e7d32' : '#757575',
              textTransform: 'uppercase',
              letterSpacing: 0.5
            }}>
              {props.menu.isActive ? t('kitchenMenus.activeStatus') : t('kitchenMenus.inactiveStatus')}
            </span>
          </Typography>
          
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: isSmallScreen ? 'flex-end' : 'flex-start', width: isSmallScreen ? '100%' : 'auto', marginBottom: isSmallScreen ? 8 : undefined, gap: 8, flexWrap: 'wrap' }}>
            <MenuEditIconButton menu={props.menu} onMenuChange={handleEditMenu} renderAsButton />
            <MenuRemoveIconButton onRemoveMenu={handleRemoveMenu} renderAsButton />
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', gap: 12, flexFlow: 'wrap' }}>
          {
            hasMenuItems ? 
            (props.menu.items.map(menuItem => (
              <MenuItemReadView key={menuItem.id} item={menuItem} menu={props.menu} chef={props.chef} onMenuChange={handleEditMenu}/>
            ))) : 
            (<div><i style={{ color: 'gray', marginLeft: 16, marginTop: -16 }}>{t('kitchenMenus.noMenuItems')}</i></div>)
          }
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', marginTop: 8 }}>
          <MenuItemCreatorEditorButton menu={props.menu} onMenuChange={handleEditMenu} />
        </div>
        
    </div>
  );
}